import React, { useState, useEffect, useReducer } from "react";
import { ManageMenuItemContainer } from "./ManageMenuItemContainer";
import { useProductsData } from "../menu/products/useProductsData";
import APIExtensions from "../../yoello-lib/modules/API2/APIDefs";
import { IMenuData } from "./types";
import { useDispatch } from "react-redux";
import { setIsDialogOpen } from "../../actions/dialog";
import { ManageMenuReducer, setMenuItems } from "./state";
import IMenuItemBody from "../../interfaces/IMenuItemBody";
import ISubCategory from "../menu/categories/ISubCategory";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { MultiDialogRoute } from "../dialogRoutes/MultiDialogRoute";
import { ManageMenuFormDialog } from "./ManageMenuFormDialog";
import Styles from "../../scss/discounts.module.scss";
import { AddExtrasFormDialog } from "../menu/products/extras/ui/AddExtrasFormDialog";
import { useTranslation } from "react-i18next";
import { ADD_ITEM, BY_ID, dialogKeys } from "../../const/URL.const";
import { ISidebarItem } from "../Routes";
import { useSideTabs } from "../../hooks/useSideTabs";
import useCheckPermissions from "../../hooks/useCheckPermissions";
import { PERMISSIONS } from "../../const/permissions.const";

interface IManageMenuContainerProps {
    venueId: string;
    subcategories: ISubCategory[];
    menuItems: IMenuItemBody[];
    isLoadingMenuData: boolean;
    tab: ISidebarItem;
}

export function ManageMenuContainer({ venueId, subcategories, menuItems, isLoadingMenuData, tab }: IManageMenuContainerProps) {
    const [menus, setMenus] = useState<IMenuData[]>([]);
    let { path } = useRouteMatch();
    const { t } = useTranslation();

    const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.MENU_MANAGEMENT);

    useSideTabs(tab);
    // const position = useSideTabs(props.tab);
    const dispatcher = useDispatch();
    //@ts-ignore
    const [state, dispatch] = useReducer(
        ManageMenuReducer,
        {
            menuItemsList: [],
            filterState: null,
            filterList: null,
            menuFormData: {},
            selectedMenuItemsList: []
        },
    );

    const { callAPI, isLoading } = useProductsData(APIExtensions.menus, venueId, setMenus, {
        "sort_field": "sort_position",
    });

    useEffect(() => {
        //@ts-ignore
        dispatch(setMenuItems(menuItems));
    }, [menuItems]);

    return <Switch>
        <Route path={path}>
            <ManageMenuItemContainer
                isLoading={isLoading || isLoadingMenuData}
                menusList={menus}
                // @ts-ignore
                manageMenuApi={callAPI}
                venueId={venueId}
                menuItemsList={state.menuItemsList}
                subcategories={subcategories}
                path={path}
                hasPermission={hasPermission}
                onFailedInteraction={onFailedInteraction}
            />
            <MultiDialogRoute RouteSteps={[{
                key: dialogKeys.MENU,
                Component: ManageMenuFormDialog,
                componentProps: {
                    hasPermission,
                    onFailedInteraction,
                    menuList: menus,
                    menuItemList: state.menuItemsList,
                    manageMenuApi: callAPI,
                    subcategories,
                    updateDialogData: () => {
                        dispatcher(setIsDialogOpen(false))
                        dispatcher(setIsDialogOpen(true))
                    },
                },
                dialogClassName: Styles.DiscountDialogContainer,
                title: t('manageMenu.form.menuTitle'),
                path: `${path}${BY_ID}`
            }, {
                key: dialogKeys.ASSIGNITEM,
                Component: AddExtrasFormDialog,
                componentProps: {
                    hasFrame: false,
                    hasFilters: true,
                    isVirtualizeList: true,
                    showOnlyMainItems: true,
                    APIDefinition: APIExtensions.menusItems
                },
                path: `${path}${BY_ID}${ADD_ITEM}`

            }]} navigateBackRotue={path}
            />
        </Route>
    </Switch>
}